/* eslint-disable react/no-deprecated */
import '@/assets/iconfont/iconfont.css';
import ReactDOM from 'react-dom';
import App from './App.tsx';
import './assets/style/rewrite.less';

// @ts-ignore
ReactDOM.render(<App />, document.getElementById('root'));
